import sortByCreatedAtDesc from '../../data_management/sorters/sort_by_created_at_desc';
import { Loader } from '../common/loader';

class ReceivedQuestionnaires {
  constructor($scope, $element, investigationInteractor, getReportInteractor) {
    this.$scope = $scope;
    this.container = $element[0];
    this.investigationInteractor = investigationInteractor;
    this.getReportInteractor = getReportInteractor;
  }

  $onInit() {
    this.loader = new Loader(this.container);
    this.investigationInteractor.withReceivedInvestigations().then(() => {
      this.loader.remove();
      this.questionnaires = this.investigationInteractor.receivedInvestigations.sort(sortByCreatedAtDesc);
      this.$scope.$digest();
    });
  }

  getReportUrl(investigation) {
    return this.getReportInteractor.getReportUrlFor(investigation);
  }
}

export default {
  name: 'receivedQuestionnaires',
  obj: {
    controller: ReceivedQuestionnaires,
    templateUrl: 'components/received_questionnaires.html'
  }
}